import { ApolloClient } from "apollo-client";
import { ApolloLink, from } from "apollo-link";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from "apollo-link-error";
import { withClientState } from "apollo-link-state";
import { setContext } from "apollo-link-context";
import { createUploadLink } from "apollo-upload-client";
import { toIdValue } from "apollo-utilities";
import { debounce } from "lodash";

import { ourToast as toast } from "./utils";

import { resolvers } from "./resolvers";

const cache = new InMemoryCache({
  dataIdFromObject: obj => `${obj.__typename}__${obj.RecId}`,
  cacheRedirects: {
    Query: {
      Direction: (_, args) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: "Direction",
            RecId: args.RecId
          })
        )
    }
  }
});

const isProduction = process.env.NODE_ENV === "production";
const uri = isProduction ? "/api" : "http://localhost:4000/";

const uploadLink = createUploadLink({
  uri
});

const consoleLink = new ApolloLink((operation, forward) => {
  console.log(`starting request for ${operation.operationName}`);
  console.log(operation.variables);
  return forward(operation).map(data => {
    console.log(`ending request for ${operation.operationName}`);
    return data;
  });
});

const displayError = debounce(message => {
  toast.error(message);
}, 500);

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path, extensions }) => {
        if (extensions.code === "FORBIDDEN") {
          localStorage.removeItem("token");
          cache.writeData({
            data: {
              authStatus: {
                __typename: "authStatus",
                status: "loggedOut"
              }
            }
          });
        }
        if (extensions.code === "BAD_USER_INPUT") {
          if (extensions.exception.invalidArgs) {
            extensions.exception.invalidArgs.forEach(arg =>
              toast.error(`${arg}`)
            );
          }
        }
        if (message === "403: Forbidden") {
          localStorage.removeItem("token");
          cache.writeData({
            data: {
              authStatus: {
                __typename: "authStatus",
                status: "loggedOut"
              }
            }
          });
        }
        displayError(message.replace(/GraphQL\serror:/g, ""));
        console.log(operation);
        return console.log(
          `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
            locations
          )}, Path: ${path}`
        );
      });
    }
    if (networkError) console.log(`[Network error]: ${networkError}`);
    return forward(operation);
  }
);

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  };
});

const stateLink = withClientState({
  cache,
  resolvers: {},
  defaults: {
    authStatus: localStorage.getItem("token")
      ? {
          __typename: "authStatus",
          status: "loggedIn",
          company: localStorage.getItem("company")
        }
      : {
          __typename: "authStatus",
          status: "loggedOut",
          company: ""
        }
  }
});
const link = from([
  // removeTypenameMiddleware,
  consoleLink,
  stateLink,
  authLink,
  errorLink,
  uploadLink
]);

export default new ApolloClient({
  resolvers,
  cache,
  link,
  defaultHttpLink: false
});
